import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error('Variáveis do Supabase ausentes. Verifique o arquivo .env em frontend/.');
}

export const supabase = createClient(url, anonKey);